import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Package, MessageSquare, FileText, Users, Percent, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(r => setS(r.data)); }, []);
  if (!s) return <div>Loading...</div>;
  const cards = [
    { l: "Total Products", v: s.total_products, i: Package, c: "#1E3A8A" },
    { l: "Published", v: s.published_products, i: Package, c: "#0F172A" },
    { l: "New Arrivals", v: s.new_arrivals, i: Star, c: "#EA580C" },
    { l: "Active Offers", v: s.active_offers, i: Percent, c: "#059669" },
    { l: "New Enquiries", v: s.new_enquiries, i: MessageSquare, c: "#EA580C" },
    { l: "Pending Quotes", v: s.pending_quotes, i: FileText, c: "#1E3A8A" },
    { l: "Customers/Leads", v: s.customers, i: Users, c: "#0F172A" },
  ];
  return (
    <div>
      <h1 className="font-heading font-extrabold text-2xl mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.l} className="bg-white border border-[#E2E8F0] rounded-md p-4">
            <div className="w-9 h-9 rounded-md flex items-center justify-center text-white" style={{background: c.c}}><c.i className="w-4 h-4"/></div>
            <div className="text-2xl font-heading font-extrabold mt-3">{c.v}</div>
            <div className="text-xs text-slate-500 mt-1">{c.l}</div>
          </div>
        ))}
      </div>
      <div className="bg-white border border-[#E2E8F0] rounded-md p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-bold">Recent Enquiries</h3>
          <Link to="/admin/enquiries" className="text-sm link-orange">View all</Link>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left border-b border-[#E2E8F0]"><tr><th className="py-2">ID</th><th>Customer</th><th>Phone</th><th>Items</th><th>Status</th></tr></thead>
            <tbody>
              {s.recent_enquiries.map(e => (
                <tr key={e.id} className="border-b border-[#E2E8F0] hover:bg-[#F8FAFC]">
                  <td className="py-2 font-mono text-xs text-[#EA580C]">{e.enquiry_id}</td>
                  <td>{e.customer_name}</td>
                  <td>{e.phone}</td>
                  <td>{(e.items || []).length}</td>
                  <td><Badge variant="outline">{e.status}</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
